import { createSlice } from '@reduxjs/toolkit';

const viandaSlice = createSlice({
	name: 'viandas',
	initialState: {
		items: [],
		status: 'idle',
		error: null,
	},
	reducers: {
		viandasCargando: (state) => {
			state.status = 'loading';
			state.error = null;
		},
		viandasCargadas: (state, action) => {
			state.items = Array.isArray(action.payload) ? action.payload : [];
			state.status = 'succeeded';
			state.error = null;
		},
		viandasError: (state, action) => {
			state.items = [];
			state.status = 'failed';
			state.error = action.payload || null;
		},
	},
});

export const { viandasCargando, viandasCargadas, viandasError } = viandaSlice.actions;

export default viandaSlice.reducer;
